import styled from 'styled-components';
import theme from '../../constants/theme';
import { circle, flexCenter } from '../../helpers/style-helpers';

export const NotificationCountSC = styled.div`
  ${circle(20)}
  ${flexCenter}

  background: ${theme.colors.error};
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 0 10px 0 rgba(255, 51, 92, 0.6);
`;
